var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.postList.edges),function(post){return _c('post',{key:post.node.id,attrs:{"id":post.node.id,"post":post.node}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }